import { tridionLabels } from '@/infrastructure/Configuration'
import { blogService } from '@/infrastructure/Factory'

export default {
  async getLabels ({ commit }) {
    const { labels } = await window.labelsService.getLabels()
    global.blogLabels = { ...tridionLabels, ...labels }

    commit('labelsLoaded', true)
  },

  async setSelectedTag ({ commit }, selectedTag) {
    commit('setSelectedTag', selectedTag)
  },

  async getArticles ({ commit, state, dispatch, getters }) {
    const params = {
      offset: state.filters.offset,
      key: state.filters.categoryId,
      limit: state.filters.limit
    }

    if (getters.getSelectedTag) {
      params.tag = getters.getSelectedTag
    }

    const articles = await blogService.getArticles(params)

    commit('setArticles', articles.blogArticles)
    commit('setTags', articles.blogArticles)
    commit('setIsInitialDataFetched', true)

    if (state.filters.offset === 1) {
      dispatch('getPromotedArticlesList')
      commit('setTotalPages', articles.totalPages)
    }
    commit('setLoadingArticles', false)
  },
  async getPromotedArticlesList ({ commit, state, dispatch, getters }, type) {
    const params = {
      pageId: state.filters.pageId
    }
    const articlesPromoted = await blogService.getPromotedArticlesList(params)
    commit('setPromotedArticles', articlesPromoted)
  }
}
